<template>
  <v-list-item>
    <v-list-item-content class="pa-0">
      <v-row class="d-flex">
        <v-col v-if="cnpj" sm="4">
          <p class="infoLabel">{{ aggregateNumber ? 'CNPJ' : 'CNPJ da empresa' }}:</p>
          <p class="infoValue">{{ cnpj }}</p>
        </v-col>
        <v-col sm="3">
          <p class="infoLabel">Telefone:</p>
          <p class="infoValue">{{ phone || 'Não Informado' }}</p>
        </v-col>
        <v-col v-if="aggregateNumber" sm="4">
          <p class="infoLabel">Quantidade de agregados:</p>
          <p class="infoValue">{{ aggregateNumber }}</p>
        </v-col>
      </v-row>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    cnpj: {
      type: String,
      required: false
    },
    phone: {
      type: String,
      required: true
    },
    aggregateNumber: {
      type: Number,
      required: false
    }
  }
};
</script>

<style scoped>
.infoLabel {
  margin: 0;
  padding: 0;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
}

.infoValue {
  margin: 0;
  padding: 0;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}
</style>